var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showViewer)?_c('el-image-viewer',{attrs:{"on-close":_vm.closeViewer,"url-list":_vm.previewImages,"initialIndex":_vm.current}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }